import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ArrowLeft, LogOut } from 'lucide-react';

export default function StaffNav({ title, backPath = '/dashboard', showBack = true }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <nav className="bg-white border-b border-gray-100 shadow-sm sticky top-0 z-20">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          {showBack && (
            <button onClick={() => navigate(backPath)}
              className="text-gray-400 hover:text-gray-600 transition p-1 rounded-lg hover:bg-gray-100">
              <ArrowLeft className="h-5 w-5" />
            </button>
          )}
          <img src="/logo-horizontal.png" alt="ShramSena" className="h-7 w-auto" />
        </div>
        <p className="text-sm font-bold text-slate-800 hidden sm:block">{title}</p>
        <div className="flex items-center gap-4">
          <span className="hidden md:block text-sm font-medium text-slate-600">{user?.firstName} {user?.lastName}</span>
          <button onClick={() => { logout(); navigate('/login'); }}
            className="flex items-center gap-1.5 text-sm font-medium text-red-500 hover:text-red-700 transition">
            <LogOut className="h-4 w-4" /><span className="hidden sm:block">Logout</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
